import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SidebarLeftComponent } from "./sidebar-left.component";
import { AngularMaterialModule } from "src/app/material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PipeModule } from "src/app/shared/pipes/pipes.module";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    PipeModule,
    ReactiveFormsModule
  ],
  declarations: [SidebarLeftComponent],
  exports: [SidebarLeftComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SideBarLeftModule {}
